import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_OUTLINE_BUTTONS, RAISED_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedOutlineButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineButton} span={RAISED_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn outline color="primary" id="Tooltip-40" className="btn-pill btn-air-primary">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-40" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary btn-air-primary</ToolTip>
          {RAISED_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonRaisedButton key={index} item={data} outline/>
          ))}
        </CardBody>
      </Card>
    );
};

export default RaisedOutlineButtons;
